export default class MapWithDefault<K, V> extends Map<K, V> {
  private default: () => V;

  get(key: K): V {
    if (!this.has(key))
      return this.set(key, this.default()).get(key);
    return super.get(key)!;
  }

  // eslint-disable-next-line prettier/prettier
  constructor(defaultFunction: () => V, entries?: readonly (readonly [K, V])[] | null) {
    super(entries);
    this.default = defaultFunction;
  }
}